import client from "../utils/client";
import {
  MediaListUrl,
  MediaUploadUrl,
  MediaFileUrl,
} from "../store/constants/api";
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const mediaService = {
  getMediaListResponse,
  MediaUploadRequest,
  MediaDeleteRequest,
};

function getMediaListResponse(pageID, perPage, favorites, searchInput) {
  let searchQuery = "";
  if (searchInput !== "") {
    searchQuery = "&search=" + searchInput;
  }

  let params = `?path=uploads/categories/images/&page=${pageID}&per_page=${perPage}${searchQuery}`;

  if (favorites) {
    params = `?path=uploads/categories/images/&page=${pageID}&per_page=${perPage}&favorites=true`;
  }

  return client
    .get(MediaListUrl + params)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function MediaUploadRequest(file, title, path, fileIndex) {
  // console.log(fileIndex);
  let formData = new FormData();
  formData.append("file", file);
  formData.append("title", title);
  formData.append("path", path);

  return client
    .post(MediaUploadUrl, formData)
    .then((response) => {
      return fileIndex;
    })
    .catch(handleResponse);
}

function MediaDeleteRequest(mediaID) {
  return client
    .get(MediaFileUrl + "/" + mediaID + "/delete?force-delete=1")
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
